import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

const MetricCard = ({ title, value, change, icon: Icon, type = 'default', isPercentage = false }) => {
  const isPositive = value >= 0;
  const isGrowthPositive = change >= 0;

  const getCardStyle = () => {
    if (type === 'profit') return 'profit-gradient text-white';
    if (type === 'loss') return 'loss-gradient text-white';
    if (type === 'primary') return 'gradient-bg text-white';
    return 'bg-white border border-gray-200';
  };

  const getTextColor = () => {
    if (type === 'profit' || type === 'loss' || type === 'primary') return 'text-white';
    return isPositive ? 'text-green-700' : 'text-red-700';
  };

  const formatValue = (val) => {
    if (isPercentage) {
      return `${val.toFixed(1)}%`;
    }
    
    const absVal = Math.abs(val);
    const sign = val < 0 ? '-' : '';
    
    if (absVal >= 10000000) {
      return `${sign}₹${(absVal / 10000000).toFixed(1)}Cr`;
    } else if (absVal >= 100000) {
      return `${sign}₹${(absVal / 100000).toFixed(1)}L`;
    } else if (absVal >= 1000) {
      return `${sign}₹${(absVal / 1000).toFixed(1)}K`;
    } else {
      return `${sign}₹${absVal.toFixed(0)}`;
    }
  };

  return (
    <div className={`metric-card ${getCardStyle()}`}>
      <div className="flex items-center justify-between mb-4">
        <div className={`p-2 rounded-lg ${type === 'default' ? 'bg-gray-100' : 'bg-white/20'}`}>
          <Icon className={`w-6 h-6 ${type === 'default' ? 'text-gray-600' : 'text-white'}`} />
        </div>
        {change !== undefined && (
          <div className={`flex items-center space-x-1 text-sm ${
            type === 'default' 
              ? (isGrowthPositive ? 'text-green-600' : 'text-red-600')
              : 'text-white/80'
          }`}>
            {isGrowthPositive ? (
              <TrendingUp className="w-4 h-4" />
            ) : (
              <TrendingDown className="w-4 h-4" />
            )}
            <span>{Math.abs(change).toFixed(1)}%</span>
          </div>
        )}
      </div>
      
      <div className="space-y-1">
        <p className={`text-sm font-medium ${
          type === 'default' ? 'text-gray-600' : 'text-white/80'
        }`}>
          {title}
        </p>
        <p className={`text-3xl font-bold ${getTextColor()}`}>
          {formatValue(value)}
        </p>
      </div>
    </div>
  );
};

export default MetricCard;